export default class AuthService {
    /* @ngInject */
    constructor($log, $q, AwsService, ManifestService, AxiosService) {
        this.$log = $log;
        this.$q = $q;
        this.ManifestService = ManifestService;
        this.AxiosService = AxiosService;

        this.AWS = AwsService.AWS;
        this.setupUnauthenticatedRole();

        this.accountKey = 'account';
        this.credentialsKey = 'credentials';
    }

    getLocalAccount() {
        const json = localStorage.getItem(this.accountKey);
        return json ? JSON.parse(json) : null;
    }

    setLocalAccount(data) {
        localStorage.setItem(this.accountKey, JSON.stringify(data));
    }

    removeLocalAccount() {
        localStorage.removeItem(this.accountKey);
    }

    getLocalCredentials() {
        const json = localStorage.getItem(this.credentialsKey);
        return json ? JSON.parse(json) : null;
    }

    setLocalCredentials(data) {
        localStorage.setItem(this.credentialsKey, JSON.stringify(data));
    }

    removeLocalCredentials() {
        localStorage.removeItem(this.credentialsKey);
    }

    getToken() {
        const account = this.getLocalAccount();
        if (account) return account.credentials.token;
        return null;
    }

    cognitoPath() {
        const region = this.ManifestService.region();
        const userPool = this.ManifestService.userPool();
        const cognitoPath = `cognito-idp.${region}.amazonaws.com/${userPool}`;
        return cognitoPath;
    }

    setupUnauthenticatedRole() {
        this.AWS.config.region = this.ManifestService.region();
        // Setting up an unauthenticated role
        this.AWS.config.credentials = new this.AWS.CognitoIdentityCredentials({
            IdentityPoolId: this.ManifestService.identityPool(),
        });
        this.AWS.config.credentials.clearCachedId();
    }

    hasCredentials() {
        const account = this.getLocalAccount();
        const credentials = this.getLocalCredentials();
        return (
            Boolean(account) &&
            Boolean(account.credentials.token) &&
            Boolean(account.credentials.refreshToken) &&
            Boolean(credentials.SessionToken) &&
            Boolean(credentials.AccessKeyId)
        );
    }

    updateAWSCredentials(credentials) {
        this.AWS.config.credentials.params.Logins = {
            [this.cognitoPath()]: credentials.token,
        };
        this.AWS.config.credentials.expired = true;
    }

    isTransportChief() {
        const CHIEF_ROLE_ID = 'dd5b4805-38d5-4c91-8d98-d9d0776ef451';
        const account = this.getLocalAccount();
        if (account.permissions.roles.indexOf(CHIEF_ROLE_ID) !== -1) {
            return true;
        }
        return false;
    }

    /**
     * @private
     */
    login(userName, password) {
        return this.AxiosService.http
            .post('auth/login', { userName, password })
            .then((response) => {
                if (response.errorMessage) {
                    throw new Error(response.errorMessage);
                }
                return response.data;
            });
    }

    /**
     * @private
     */
    credentials(identityId, token) {
        const identity = new this.AWS.CognitoIdentity({
            region: this.ManifestService.region(),
        });

        return identity
            .getCredentialsForIdentity({
                IdentityId: identityId,
                Logins: { [this.cognitoPath()]: token },
            })
            .promise()
            .then(response => response.Credentials);
    }

    /**
     * @private
     */
    refresh(refreshToken) {
        return this.AxiosService.http
            .post('auth/refresh', { refreshToken })
            .then((response) => {
                if (response.errorMessage) {
                    throw new Error(response.errorMessage);
                }
                return response.data;
            });
    }

    authenticate(userName, password) {
        return this.$q((resolve, reject) => {
            this.login(userName, password)
                .then((account) => {
                    this.updateAWSCredentials(account.credentials);
                    this.setLocalAccount(account);
                    return account;
                })
                .then(account =>
                    this.credentials(
                        account.credentials.identityId,
                        account.credentials.token,
                    ),
                )
                .then(credentials => this.setLocalCredentials(credentials))
                .then(account => resolve(account))
                .catch(error => reject(error));
        });
    }

    refreshCredentials() {
        this.setupUnauthenticatedRole();

        return this.$q((resolve, reject) => {
            const localAccount = this.getLocalAccount();
            if (!localAccount) {
                reject();
                return;
            }
            const refreshToken = localAccount.credentials.refreshToken;

            this.refresh(refreshToken)
                .then((account) => {
                    this.updateAWSCredentials(account.credentials);
                    this.setLocalAccount(account);
                    return account;
                })
                .then(account =>
                    this.credentials(
                        account.credentials.identityId,
                        account.credentials.token,
                    ),
                )
                .then(credentials => this.setLocalCredentials(credentials))
                .then(() => resolve())
                .catch(error => reject(error));
        });
    }

    logout() {
        this.removeLocalAccount();
        this.removeLocalCredentials();

        if (this.AWS.config.credentials) {
            this.AWS.config.credentials.clearCachedId();
        }
        this.setupUnauthenticatedRole();
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.js